import CVCButton from './CVCButton.view';

export default CVCButton;
